import api from "../../services/api";

// Métrica de chamados finalizados sem interação com o contato.
// Endpoint restrito a administradores (dado gerencial por atendente).
const useNoInteractionClosures = () => {
  const find = async (params) => {
    const { data } = await api.get("/dashboard/noInteractionClosures", {
      params,
    });
    return data;
  };

  return { find };
};

export default useNoInteractionClosures;
